import React, { ReactElement } from 'react';

// assets
import ThumbsUpIcon from 'assets/images/videoReactions/ThumbsUpIcon';
import ThumbsDownIcon from 'assets/images/videoReactions/ThumbsDownIcon';
import LaughingIcon from 'assets/images/videoReactions/LaughingIcon';
import LoveItIcon from 'assets/images/videoReactions/LoveItIcon';
import ClappingIcon from 'assets/images/videoReactions/ClappingIcon';
import WowIcon from 'assets/images/videoReactions/WowIcon';
import CommentsIcon from 'assets/images/videoReactions/CommentsIcon';
import CommentsCountIcon from 'assets/images/videoReactions/CommentsCountIcon';

export enum VIDEO_REACTION_TYPE {
  COMMENT = 1,
  EMOTE = 2,
}

export type VideoReactionsDictionaryType = {
  [key: number]: VideoReaction;
};

export type VideoReaction = {
  id: number;
  title: string;
  icon: ReactElement;
  smallIcon: ReactElement;
  type: VIDEO_REACTION_TYPE;
};

export const VideoReactionsDictionary: VideoReactionsDictionaryType = {
  1: {
    id: 1,
    title: 'Thumbs up',
    icon: <ThumbsUpIcon width={30} height={30} />,
    smallIcon: <ThumbsUpIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
  2: {
    id: 2,
    title: 'Thumbs down',
    icon: <ThumbsDownIcon width={30} height={30} />,
    smallIcon: <ThumbsDownIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
  3: {
    id: 3,
    title: 'Laughing',
    icon: <LaughingIcon width={30} height={30} />,
    smallIcon: <LaughingIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
  4: {
    id: 4,
    title: 'Love it',
    icon: <LoveItIcon width={30} height={30} />,
    smallIcon: <LoveItIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
  5: {
    id: 5,
    title: 'Clapping',
    icon: <ClappingIcon width={30} height={30} />,
    smallIcon: <ClappingIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
  6: {
    id: 6,
    title: 'Wow',
    icon: <WowIcon width={30} height={30} />,
    smallIcon: <WowIcon width={20} height={20} />,
    type: VIDEO_REACTION_TYPE.EMOTE,
  },
};

export const VideoComentsDictionary: VideoReaction = {
  id: 7,
  title: 'Comments',
  icon: <CommentsIcon />,
  smallIcon: <CommentsCountIcon />,
  type: VIDEO_REACTION_TYPE.COMMENT,
};
